import { Component, OnInit , ElementRef, Renderer2} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { Location } from '@angular/common';

@Component({
  selector: 'echexpayment-status',
  templateUrl: './statusform.component.html',
  styleUrls: ['./status.component.css']
})
export class CreatestatusComponent implements OnInit {
  addStatus: boolean = true;
  editStatus: boolean = false;
  busy: Subscription;
  public color: string = "#127bdc";
  public token: string;
  public validation_status_name :boolean = false;
  public validation_status_color :boolean = false;
  public validation_status_code :boolean = false;
  public validation_status_id :boolean = false;

  public status: any = {};
  NamecharacterLimitReached: { [key: string]: boolean } = {};
  
  constructor(private router: Router, private location : Location, private toastr: ToastrService, private renderer :  Renderer2, private elementRef : ElementRef, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 
	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;

  }

  ngOnInit() {
  }
  
  // Get color code	
   getColorCode(event){
      this.status.status_color = event;
   }
  // event handler for validation	
  eventHandler(){
      this.validation_status_name = false;
      this.validation_status_color = false;
      this.validation_status_code = false;
      this.validation_status_id = false;
    }

  goBack(){
     this.location.back();
  }

  onColorInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value.trim();

    // If the input value is empty, set the color to null
    if (inputValue === '') {
      this.status.status_color = null;
    }
  }


  // Save status
  saveStatus(data) {
    this.focusFirstInvalidControlPlus();   //focus field
		if(data.valid && this.status.status_color){
			    let model: any = data.value;
          this.validation_status_name = false;
          this.validation_status_color = false;
          this.validation_status_code = false;
          this.validation_status_id = false;
          if(typeof model.status_id === 'undefined'  || model.status_id === null || model.status_id === ''){
              this.validation_status_id = true;
              return false;
          }
          if(typeof model.status_name === 'undefined'  || model.status_name === null || model.status_name === ''){
              this.validation_status_name = true;
              return false;
          }
        if(typeof model.status_code === 'undefined'  || model.status_code === null || model.status_code === ''){
              this.validation_status_code = true;
              return false;
          }

        model.token = this.token
        model.status_color = this.status.status_color ? this.status.status_color : this.color;
        let responseData = <any>{};
        this.busy = this.echexpaymentService.createStatus(model).subscribe(
          response => {
        responseData = response;
                this.toastr.success(responseData.message, 'Success!');
                this.router.navigate(['/status']);
          },
          error => {
          responseData = error;
          this.toastr.error(responseData.error.message, 'Failed!');
          }
        );
      }
  }

  // Focus Error Field
  focusFirstInvalidControlPlus(): void {
    const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
    if (firstElementWithErrors) {
      firstElementWithErrors.focus();
    }
  }

  // Enter Key Focus Next Field
  moveNext(nextInput: HTMLInputElement, checkbox: number = 0) {
    if(checkbox === 2){
      const saveButton = document.getElementById('submitButton') as HTMLElement;
      if (saveButton) {
        saveButton.focus();
        saveButton.click();
      }
    } else{
      nextInput && nextInput.focus();
    }
  }

  ngAfterViewInit(){
    this.renderer.selectRootElement('#InitialFocus').focus();
  }

  NameCharacterLimit(event: any, fieldName: string) {
    const maxTextLength = 25; // Maximum text length of 20 characters
    const inputChar = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
    const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
  
    if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
      return;
    }
  
    const inputValue = event.target.value;
  
    if (inputValue.length >= maxTextLength) {
      if (allowedKeys.indexOf(inputChar) === -1) {
        this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
        setTimeout(() => {
          this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
        }, 3000);
        event.preventDefault(); // Prevent entering the exceeded character
      }
    }
  }
  
  isNameLimitReached(fieldName: string): boolean {
    return this.NamecharacterLimitReached[fieldName];
  }


  // disallow 0
  validateNumberInput(event: any) {
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
    const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
    
    if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
      // Allow the default behavior for certain keys
      return;
    }
    
    if (!/^\d+$/.test(event.key)) {
      // Prevent input if it's not a digit
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/status/createstatus.component.ts